// AuthContext.js
import React, { createContext, useContext, useState  } from 'react';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

/* ---------------------------------------------------------------------------
   TOKEN FRESHNESS (changed)
   `userData` used to be read from localStorage ONCE at module load, and
   getToken() returned that frozen snapshot for the life of the bundle. Because
   login/logout write localStorage through full-page reloads, that staleness was
   mostly masked - but any login or logout that happens WITHOUT a reload would
   leave getToken() (and therefore every Axios Authorization header built from it)
   returning the previous session's token, or no token at all.

   getToken() now reads localStorage at call time. The returned value, the token
   field, and the "undefined when absent" behaviour are unchanged - this only
   removes the caching.

   PREVIOUS (kept for restore):
   const userData = JSON.parse(localStorage.getItem('user'));
   export const getToken = () => {
     return userData?.access_token;
   };
--------------------------------------------------------------------------- */
export const getToken = () => {
  try {
    const userData = JSON.parse(localStorage.getItem('user'));
    return userData?.access_token; // undefined when no user is stored
  } catch (error) {
    // Unreadable/corrupt localStorage must not throw on every API call.
    return undefined;
  }
};

// `userData` is still needed by AuthProvider below for its initial state, and is
// still read at module scope for that purpose only. It is no longer used by
// getToken().
const userData = JSON.parse(localStorage.getItem('user'));


export const AuthProvider = ({ children }) => {
  const [loggedIn, setLoggedIn] = useState(userData?.user); 
  const [user, setUser] = useState(userData?.user); 

  const handleLogin = () => {
    setUser(userData?.user);
    setLoggedIn(true); 
  };

  const handleLogout = () => { 
    setLoggedIn(false);
  };

  
  return (
    <AuthContext.Provider value={{ loggedIn, handleLogin, handleLogout, user, getToken,  }}>
      {children}
    </AuthContext.Provider>
  );
};
